import setCompanies from './setCompanies'

function getUserForUsersArray(input, state) {
  let user = input.result.user
  let currentClient = user.currentClient
  const listModule = state.get('app.listModule')

  const access = currentClient.modules.reduce((acc, module) => {
    if (module.module === listModule) {
      acc = module.access
    }
    return acc
  }, null)

  let companies = []
  setCompanies(companies, currentClient.visiting)
  setCompanies(companies, currentClient.delivery)
  setCompanies(companies, currentClient.invoice)
  let newUser = {
    firstname: user.firstname,
    lastname: user.lastname,
    email: user.email,
    _id: user._id,
    validFrom: currentClient.validFrom,
    validTo: currentClient.validTo,
    lastLogin: currentClient.lastLogin,
    companies: companies,
    modules: currentClient.modules.reduce((acc, item) => {
      acc[item.module] = item.group
      return acc
    }, {}),
    access
  }
  return newUser
}

export default getUserForUsersArray



// WEBPACK FOOTER //
// ./src/modules/user/helpers/getUserForUsersArray.js